export default {
  'createbusinessprofile.createbusinessprofile': 'Crea Profilo Aziendale',
};
